import { createContext } from 'react';

/**
 * Marker for which page mounted the HQV modal tree.
 *
 * Set by the modal owner (SearchResultsMainComponent for SERP, SearchFormComponent for ADF,
 * HQVWrapper for SWR mode) around <PageonModal>. Consumed by shared modal readers
 * (HotelOverview/*, HotelInformation/*, HotelGallery*) via useConditionalHQVContext so they
 * honor the correct page's feature flag instead of OR-combining SERP and ADF flags.
 *
 * Defaults to null so that useConditionalHQVContext can fall back to 'serp' when the
 * provider is absent (preserves behavior for any lingering non-modal callers).
 */
export type HQVModalFlagType = 'serp' | 'adf';

export const HQVModalFlagContext = createContext<HQVModalFlagType | null>(null);
